import React from "react";
import { ClientServiceTermsSetUpSubHeader } from "../../layouts/ClientServiceTermsManagementLayout";
import ServiceLevelAgreementsAdmin from "../../features/servicelevelagreementadmin";

const ServiceTermsSetupPage = () => {
    const [showCreateModal, setShowCreateModal] = React.useState(false);

    return <React.Fragment>
        <ClientServiceTermsSetUpSubHeader onCreateClick={() => setShowCreateModal(true)} />
        <section className="px-4 my-3 h-100">
            <ServiceLevelAgreementsAdmin showCreateModal={showCreateModal} setShowCreateModal={setShowCreateModal} />
        </section>
    </React.Fragment>
}



export default ServiceTermsSetupPage;